export default class QueueListController {
    constructor(JobsLog) {
        this.store = JobsLog;
    }
}

QueueListController.$inject = [
    'JobsLog'
];



// WEBPACK FOOTER //
// ./src/app/pages/queue/controllers/list-controller.js